var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCredit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M37.5833 20.5001C37.5833 29.9369 29.9351 37.5834 20.5 37.5834C11.0649 37.5834 3.41667 29.9369 3.41667 20.5001C3.41667 11.0667 11.0649 3.41675 20.5 3.41675C29.9351 3.41675 37.5833 11.0667 37.5833 20.5001Z",
    fill: "#46BCB1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6054 27.0164C26.3816 27.0164 26.1561 26.9583 25.9494 26.837L19.2425 22.8361C18.8564 22.6037 18.619 22.1852 18.619 21.7342V13.1123C18.619 12.4051 19.193 11.8311 19.9002 11.8311C20.6075 11.8311 21.1815 12.4051 21.1815 13.1123V21.0064L27.2631 24.6332C27.8696 24.9971 28.0695 25.7829 27.7073 26.3911C27.4664 26.7926 27.041 27.0164 26.6054 27.0164Z",
    fill: "#46BCB1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCredit);
export default __webpack_public_path__ + "static/media/credit.c7377285a5f3ab2ab659275c9c41e000.svg";
export { ForwardRef as ReactComponent };